import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Quiz App React Context Provider
import { MaterialUIControllerProvider } from "context";
import { Provider } from "react-redux";
import { store } from "App/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css"
const container = document.getElementById("app");
const root = createRoot(container);


root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <Provider store={store}>
        <App />
        <ToastContainer autoClose={3000} bodyClassName="custom-toast-body" />
      </Provider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
